<template>
  <div>
    <h1>Impressum</h1>
    <section>
      <p>Tobias Hubold Thomas-Mann-Straße 11 07743 Jena</p>
      <p>e-Mail: kontakt@tobiashubold.de</p>
      <p>Plattform der EU-Kommission zur Online-Streitbeilegung: https://ec.europa.eu/odr</p>
      <p>Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle weder verpflichtet noch bereit.</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'RTimpressum',
  data: function() {
    return {
    };
  },
};
</script>

<style scoped type='text/css'>

</style>